<template lang="pug">
    Component(:is="displayComponent.component" v-bind="displayComponent.props" ref="Tabs")
        template(#description)
            Description
        template(#fits)
            Applications
        template(#details)
            Details
        template(#videos)
            Videos(:renderType="displayComponent.component" :videos="pData.videos ? pData.videos.videos : []")
        template(#warranty)
            Warranty
        template(#install)
            Installation(:renderType="displayComponent.component")
        template(#reviews)
            Reviews(:yotpoId="pData.yotpoId" :yotpoName="pData.name")
        template(#Q&A)
            Questions(:yotpoId="pData.yotpoId" :yotpoName="pData.name")
        template(#[customerPhotos])
            CustomerPhotos(v-if="!!$sitewideData.config.yotpoProductGalleryId" :yotpoId="pData.yotpoId" :galleryId="$sitewideData.config.yotpoProductGalleryId")
</template>

<script>
import Reviews from '@/integrations/yotpo/reviews'
import Questions from '@/integrations/yotpo/questions'
import Description from './description'
import Warranty from './warranty'
import Installation from './installation'
import Details from './details'
import Applications from './applications'
const TabsScroller = () =>
    import(/* webpackChunkName: "component-tabs-scroller" */ '@/components/tabs/scroller')
const Panels = () => import(/* webpackChunkName: "component-panels" */ './panels')
const Videos = () =>
    import(/* webpackChunkName: "structured-video-collection" */ '@/components/video/collection')
const CustomerPhotos = () =>
    import(/* webpackChunkName: "yotpo-customer-photos" */ '@/integrations/yotpo/customerPhotos')

export default {
    name: 'ExtraInformation',
    components: {
        TabsScroller,
        Panels,
        Description,
        Videos,
        Warranty,
        Installation,
        Details,
        Applications,
        Reviews,
        Questions,
        CustomerPhotos,
    },
    props: {
        hasCustomerPhotos: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            customerPhotos: 'Customer Photos',
        }
    },
    computed: {
        displayComponent() {
            if (this.$device.isSmall) {
                return {
                    component: 'Panels',
                    props: {
                        tabsArray: this.tabProps,
                    },
                }
            } else {
                return {
                    component: 'TabsScroller',
                    props: {
                        tabsArray: this.tabProps,
                    },
                }
            }
        },
        tabProps() {
            /** Important
             *
             * The order of this array also determines the order these tabs will appear.
             * 'name' must be the same as Slot='' above in the template and is also
             * what appears on screen.
             *
             */
            const array = [
                {
                    name: 'description',
                    class: '-hideTitle',
                },
            ]
            if (this.isProductPage && this.pData.applications && this.pData.applications.length > 0)
                array.push({ name: 'fits' })
            if (
                this.pData.howItWorks ||
                this.pData.additionalFeatures ||
                this.pData.faq ||
                this.pData.specifications
            )
                array.push({ name: 'details' })
            if (this.pData.videos) array.push({ name: 'videos' })
            if (this.pData.installation) array.push({ name: 'install' })
            if (this.pData.warranty) array.push({ name: 'warranty' })
            if (this.$yotpo.enabled && this.pData.yotpoId) {
                if (this.hasCustomerPhotos) array.push({ name: 'Customer Photos' })
                array.push({ name: 'reviews' })
                array.push({ name: 'Q&A' })
            }
            return array
        },
        pData() {
            return this.$store.state.product.data
        },
        isProductPage() {
            return this.$route.meta.isProductPage
        },
    },
}
</script>
